import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ConfigProvider } from 'antd';
import Color from './constants/ColourConstants';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ConfigProvider
      theme={{
        token: {
          ...Color,
        },
        components: {
          Layout: {
            lightSiderBg: Color.colorBgLayout,
            bodyBg: Color.colorBgContainer,
          },
          Menu: {
            itemBg: Color.colorBgLayout,
            itemColor: Color.colorTextBase,
            itemSelectedColor: Color.colorWhite,
            itemSelectedBg: Color.colorPrimary,
            itemBorderRadius: '100px',
          },
          Table: {
            rowExpandedBg: Color.colorWhite,
            rowSelectedBg: Color.colorWhite,
            rowSelectedHoverBg: Color.colorFillAlter,
          },
        },
      }}
    >
      <App />
    </ConfigProvider>
  </React.StrictMode>,
);
